
import { Vue } from 'vue-class-component';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';
import router from '@/router';
import ErrorCode from '@/constants/ErrorCode';
import SetPasswordModel from '@/models/login/setPasswordModel';
import CurrentUserService from '@/services/currentUserService';
import LoginModel from '@/models/login/LoginModel';
import LoginService from '@/services/loginService';
import CommonValidate from '@/services/commonValidate';

export default class Login extends Vue {
    private loginForm = new LoginModel();

    private updateForm = new SetPasswordModel();

    private showLogin = true;

    private rules = {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    };

    private checkPass = (rule: any, value: any, callback: any) => {
        if (value !== this.updateForm.newPassword) {
            callback(new Error('两次输入密码不一致'));
        } else {
            callback();
        }
    };

    private passRules = {
        newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { validator: CommonValidate.validatePass, trigger: 'blur' },
        ],
        checkPassword: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { validator: this.checkPass, trigger: 'blur' },
        ],
    };

    private loginSuccessRoute = '/';

    mounted(): void {
        const redirect = this.$route.query?.redirect;
        if (redirect) {
            this.loginSuccessRoute = redirect.toString();
        }
    }

    login(): void {
        const form: any = this.$refs.formLogin;
        form.validate((valid: boolean) => {
            if (valid) {
                const loadingInstance = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                const result = LoginService.login(this.loginForm);
                result
                    .then((p) => {
                        loadingInstance.close();
                        if (p.code === ErrorCode.Success) {
                            CurrentUserService.SetUserInfo(
                                this.loginForm.username.toUpperCase(),
                                p.data.access_Token
                            );
                            router.push(this.loginSuccessRoute);
                        } else if (p.code === ErrorCode.InitLogin) {
                            ElMessageBox.alert(p.msg, '提示', {
                                confirmButtonText: '确定',
                                showClose: false,
                                callback: () => {
                                    this.showLogin = false;
                                },
                            });
                        } else if(p.code === ErrorCode.LoginAccountOrPasswordError) {
                            ElMessage.error('账号或密码错误');
                        } else {
                            ElMessage.error(p.msg);
                        }
                    })
                    .catch((error) => {
                        loadingInstance.close();
                        console.info(error);
                        ElMessage.error(error);
                    });
            }
        });
    }

    setPassword(): void {
        const form: any = this.$refs.formPass;
        form.validate((valid: boolean) => {
            if (valid) {
                const loadingInstance = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                this.updateForm.password = this.loginForm.password;
                this.updateForm.username = this.loginForm.username;
                const result = LoginService.setPassword(this.updateForm);
                result
                    .then((p) => {
                        loadingInstance.close();
                        if (p.code === ErrorCode.Success) {
                            router.push(this.loginSuccessRoute);
                            CurrentUserService.SetUserInfo(
                                this.loginForm.username,
                                p.data.access_Token
                            );
                        } else {
                            ElMessage.error(p.msg);
                        }
                    })
                    .catch((error) => {
                        loadingInstance.close();
                        console.info(error);
                        ElMessage.error(error);
                    });
            }
        });
    }
}
